export const ALARM_ATOM_KEYS = {
  CONFIRM_ALARM_LIST: 'confirm_alarm_list',
  ALARM_INPUT_DATA: 'alarm_input_data',
} as const
